import React from 'react';
import { Instagram } from 'lucide-react';
import { Logo } from './Header';
import { INSTAGRAM_URL, INSTAGRAM_HANDLE, WHATSAPP_DISPLAY, REGION } from '../data/site';

const Footer = () => (
  <footer data-testid="footer" className="border-t border-line px-4 pb-28 pt-12 md:px-8 md:pb-12">
    <div className="mx-auto grid max-w-7xl gap-8 md:grid-cols-3 md:items-end">
      <div>
        <Logo />
        <p className="mt-3 text-sm text-soft">DJ Paulo. DJ, som e iluminação para eventos em {REGION}.</p>
      </div>
      <p className="text-sm text-soft md:text-center">WhatsApp {WHATSAPP_DISPLAY}</p>
      <a
        href={INSTAGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-sm text-soft transition-colors hover:text-ink md:justify-self-end"
        data-testid="footer-instagram-link"
      >
        <Instagram size={16} aria-hidden="true" /> {INSTAGRAM_HANDLE}
      </a>
    </div>
    <p className="mx-auto mt-10 max-w-7xl text-xs text-soft">© {new Date().getFullYear()} Atitude Som e Luz</p>
  </footer>
);

export default Footer;
